import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export const useTrackJ52BidPlaced = () => useTrackConversion({ goal: KameleoonGoalData.J52BidPlaced });
